export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: ['ja', 'nein'],
    OFFLINE_MESSAGE:
      'Es tut mir leid, ich habe im Moment keine Internet Verbindung. Ich kann Ihre Antwort im Moment nicht bearbeiten.'
  }
}
